export const formatBRL = (value) => {
    const n = Number(value || 0);
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatDateBR = (iso) => {
    if (!iso) return '—';
    const datePart = String(iso).slice(0, 10);
    const [y, m, d] = datePart.split('-');
    if (!y || !m || !d) return iso;
    return `${d}/${m}/${y}`;
};

export const formatTimeBR = (iso) => {
    if (!iso) return '—';
    const dt = new Date(iso);
    return dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });
};

export const formatDateTimeBR = (iso) => {
    if (!iso) return '—';
    return `${formatDateBR(iso)} ${formatTimeBR(iso)}`;
};

export const durationBetween = (start, end) => {
    if (!start || !end) return '—';
    const ms = new Date(end) - new Date(start);
    if (ms < 0) return '—';
    const h = Math.floor(ms / 3600000);
    const min = Math.floor((ms % 3600000) / 60000);
    return `${h}h ${min}min`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
